export enum FulfillmentLineType {
  Delivery = 'Delivery',
  ReturnDelivery = 'ReturnDelivery',
  Operation = 'Operation',
  UnifiedService = 'UnifiedService',
  Exchange = 'Exchange'
}
